import React from 'react';
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../redux/hooks";
import { RootState } from "../../redux/store";
import styles from "./AuthFailed.module.scss";
import { ReactComponent as AuthorizationFailedLightImg } from "../../assets/images/LightTheme/authorization_failed.svg";
import { ReactComponent as AuthorizationFailedDarkImg } from "../../assets/images/DarkTheme/authorization_failed.svg";
import Button from "../common/Button/Button";
import RefreshLogoLight from "../../assets/images/LightTheme/refresh_icon.svg";
import RefreshLogoDark from "../../assets/images/DarkTheme/refresh_icon.svg";
import authService from "../../config/auth.service";

function handleClickRefresh() {
  authService.clearAuth();
  return window.location.href = "/myaccount"
}

function AuthFailed() {
    const { t } = useTranslation();
    const currentTheme = useAppSelector((state: RootState) => state.theme.currentTheme);
    const AuthorizationFailedImg =
        currentTheme === "light" ? AuthorizationFailedLightImg : AuthorizationFailedDarkImg;

    const RefreshLogo = currentTheme === "light" ? RefreshLogoLight : RefreshLogoDark;

    const customButtonStyles: React.CSSProperties = {
        backgroundColor: "#151515",
        border: "2px solid var(--text-text-primary, #D8D8D9)"
    };

    return (
        <div className={`${styles.error_container}`}>
            <div>
                <AuthorizationFailedImg />
            </div>
            <div className={styles.error_message_section}>
                <div className={styles.error_message_1}>{t("authorization_failed")}</div>
                <div className={styles.error_message_2}>{t("authorization_failed_subtext")}</div>
            </div>
            <div className={styles.refresh_button}>
                <Button
                    id="cancelButton"
                    isImg={true}
                    iconName={RefreshLogo}
                    onClick={handleClickRefresh}
                    label={t("refresh")}
                    style="unfilled"
                    customStyle={currentTheme === "light" ? {} : customButtonStyles}
                    themeColor={currentTheme === "light" ? "#2C2C2C" : "#D8D8D9"}
                />
            </div>
        </div>
    );
}

export default AuthFailed;